module.exports = __webpack_public_path__ + "img/Flag_of_Poland.dfb064d1.svg";